// Import model
import { DateRangePreset } from '../models/DateRangePreset';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DateRangePreset - handles JSON serialization and deserialization with type validation
 */
export class DateRangePresetSerializer {
  /**
   * Deserializes a JSON string into a DateRangePreset instance
   */
  static deserialize(json: string): DateRangePreset {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DateRangePreset instance
   */
  static fromObject(obj: any): DateRangePreset {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DateRangePreset');
    }


    const instance: DateRangePreset = {
      name: obj['Name'] as string | undefined,
      range: obj['Range'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DateRangePreset instances
   */
  static deserializeArray(json: string): DateRangePreset[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DateRangePreset instance to a JSON string
   */
  static serialize(instance: DateRangePreset): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DateRangePreset instance to a plain object
   */
  static toObject(instance: DateRangePreset): any {
    return {
      'Name': instance.name,
      'Range': instance.range,
    };
  }

  /**
   * Serializes an array of DateRangePreset instances to a JSON string
   */
  static serializeArray(instances: DateRangePreset[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
